<cass-core-toolbar></cass-core-toolbar>
<div class='page-container'>
	<mat-card class="branding--title-card">
		<mat-card-content>
			<h1>{{ "DASHBOARD.MAIN_TITLE" | translate }}</h1>
		</mat-card-content>
	</mat-card>
	<div class='widgets-container' [ngClass]="{ 'show-recent-advertisers': userProfilesService.userHasMultipleCustomers$ | async, 'show-chat-widget': enableChatToPublishers && enableChatToPublishers.length > 0 }">
		<div class="dashboard-widget notifications-widget">
			<mat-card class="branding--section-card">
				<mat-card-content>
					<h2>{{ "DASHBOARD.NOTIFICATION_TITLE" | translate }}
						<div class="section-card-button-container">
							<button routerLink="/notifications" mat-button color="accent">{{ "DASHBOARD.ACTION_BUTTON_LABELS.SHOW_ALL" | translate }}</button>
						</div>
					</h2>
				</mat-card-content>
			</mat-card>
			<app-notifications-list showNewSinceLastLogin></app-notifications-list>
		</div>
		<div *ngIf="enableChatToPublishers && enableChatToPublishers.length > 0" class="dashboard-widget chats-widget">
			<mat-card class="branding--section-card">
				<mat-card-content>
					<h2>{{ "DASHBOARD.CHAT_MESSAGES_TITLE" | translate }}
						<div class="section-card-button-container">
							<button routerLink="/messages" mat-button color="accent">{{ "DASHBOARD.ACTION_BUTTON_LABELS.SHOW_ALL" | translate }}</button>
						</div>
					</h2>
				</mat-card-content>
			</mat-card>
			<app-chat-conversations-list showUnreadOnly="false" (onMessageClick)="messageClicked($event)"></app-chat-conversations-list>
		</div>
		<div class="dashboard-widget orders-widget">
			<mat-card class="branding--section-card">
				<mat-card-content>
					<h2>{{ "DASHBOARD.RECENT_ORDERS_TITLE" | translate }}
						<div class="section-card-button-container">
							<button mat-stroked-button (click)="createOrder()">
								{{ "DASHBOARD.ACTION_BUTTON_LABELS.NEW_ORDER" | translate }}</button>
							<button routerLink="/myads" mat-button color="accent">{{ "DASHBOARD.ACTION_BUTTON_LABELS.SHOW_ALL" | translate }}</button>
						</div>
					</h2>
				</mat-card-content>
			</mat-card>
			<cass-my-ads-list [displayMode]="'showRecent'"></cass-my-ads-list>
		</div>
		<div class="dashboard-widget customers-widget" *ngIf="userProfilesService.userHasMultipleCustomers$ | async">
			<mat-card class="branding--section-card">
				<mat-card-content>
					<h2>{{ "DASHBOARD.RECENT_ADVERTISERS" | translate }}
						<div class="section-card-button-container">
							<button mat-button color="accent" (click)="showAllAdvertisers()">{{ "DASHBOARD.ACTION_BUTTON_LABELS.SHOW_ALL" | translate }}</button>
						</div>
					</h2>
				</mat-card-content>
			</mat-card>
			<app-customers-list [customers$]="recentCustomers$"></app-customers-list>
		</div>
	</div>
</div>
